// src/contexts/PedidosContext.tsx
import React, { createContext, useContext, useState, useMemo, ReactNode } from 'react';

// NUEVO: Notificación global para eventos
export interface GlobalNotification {
  notification_id: string;
  topic: string;
  message: string;
  [key: string]: any;
}

interface ReservationDetails {
  reservation_id: number;
  client_id: number | null; // Allow null for compatibility with ReservationModal
  client_name: string;
  email: string;
  phone_number: string;
  reservation_date: string; // Date in 'YYYY-MM-DD' format
  local_id: number;
  init: number; // Start time as a slot (e.g., 18 for 6:00 PM)
  end: number; // End time as a slot (e.g., 20 for 8:00 PM)
  n_people: number; // Number of people for the reservation
  mesa_id: number; // Table ID
  mesa_num: number; // Table number
  tag?: string; // Optional table tag
  description: string; // Description of the reservation
  confirmed: boolean; // Whether the reservation is confirmed
  approved: boolean; // Whether the reservation is approved
  attended: boolean; // Whether the reservation was attended
  cancelled: boolean; // Whether the reservation was cancelled
  arrived: boolean; // Whether the reservation has arrived
}

type NotificationsContextType = {
  reservations: ReservationDetails[];
  setReservations: React.Dispatch<React.SetStateAction<ReservationDetails[]>>;
  // Notificación global
  lastNotification: GlobalNotification | null;
  setLastNotification: React.Dispatch<React.SetStateAction<GlobalNotification | null>>;
};

const NotificationsContext = createContext<NotificationsContextType | null>(null);

export function NotificationsProvider({ children }: { children: ReactNode }) {
  const [reservations, _setReservations] = useState<ReservationDetails[]>([]);
  // NUEVO: Estado para la última notificación global
  const [lastNotification, setLastNotification] = useState<GlobalNotification | null>(null);

  // Wrap the real setter with a logger/tracer
  const setReservations: typeof _setReservations = (updater) => {
    //console.group('🔄 setPedidos called');
    //console.trace();
    //console.log('→ Updater argument:', updater);
    //console.groupEnd();
    return _setReservations(updater);
  };

  // Only re-create this object when `reservations` o `lastNotification` cambian
  const value = useMemo(
    () => ({
      reservations,
      setReservations,
      lastNotification,
      setLastNotification
    }),
    [reservations, lastNotification]
  );

  return <NotificationsContext.Provider value={value}>{children}</NotificationsContext.Provider>;
}

export function useNotifications() {
  const ctx = useContext(NotificationsContext);
  if (!ctx) throw new Error('usePedidos must be used within a PedidosProvider');
  return ctx;
}